const DEFAULT_AMP_CONFIG = {
    key: '9557123af2b72c2a678b12154377ba01',
    version: '1.4.15',
    protocol: 'https',
    hostAndPath: 'webapi.amap.com/maps',
    plugin: [],
};
export default class AMapAPILoader {
    /**
     * 初始化参数
     * @param config
     */
    constructor(config) {
        this._config = {
            ...DEFAULT_AMP_CONFIG,
            ...config
        };
        this._document = document;
        this._window = window;
    }

    load() {
        if (this._scriptLoadingPromise) return this._scriptLoadingPromise;
        this.loaded = false;
        this._scriptLoadingPromise = new Promise((resolve, reject) => {
            if(this.loaded){
                resolve();
                return;
            }
            const script = this._document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.src = this._getScriptSrc();

            this._document.head.appendChild(script);
            script.onload = () => {
                this.loaded = true;
                setTimeout(resolve, 0);
            };
            script.onerror = () => reject();
        });
        return this._scriptLoadingPromise;
    }
    _getScriptSrc(){
        return `${this._config.protocol}://${this._config.hostAndPath}?v=${this._config.version}&key=${this._config.key}`;
    }
}


// WEBPACK FOOTER //
// ./src/components/deliveryDetail/AMapApiLoad.js